import { logger } from '../utils/logger';
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true, // Importante para enviar y recibir cookies HTTP-only
  // Evitar que Axios siga automáticamente las redirecciones
  maxRedirects: 0,
});

// Interceptor de petición para añadir token si existe
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor de respuesta para manejar errores de autenticación
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    logger.log('=== API INTERCEPTOR ERROR ===');
    logger.log('Error status:', error.response?.status);
    logger.log('Error URL:', error.config?.url);
    logger.log('Current path:', window.location.pathname);
    logger.log('Error response:', error.response);

    // Solo redirigir a Cognito desde rutas protegidas
    const currentPath = window.location.pathname;
    const publicPaths = [
      '/login',
      '/',
      '/register',
      '/forgot-password',
    ];
    const isPublicPath = publicPaths.includes(currentPath);

    // Manejar redirecciones (status 302) que apuntan a Cognito
    if (error.response?.status === 302 && !isPublicPath) {
      logger.log('Handling 302 redirect');
      const redirectUrl = error.response.headers.location;

      // NO interceptar redirecciones de logout - dejar que el backend las maneje
      if (error.config?.url?.includes('/auth/logout')) {
        logger.log('Skipping logout redirect interception');
        return Promise.reject(error);
      }

      if (redirectUrl && redirectUrl.includes('amazoncognito.com')) {
        logger.log('Redirecting to Cognito:', redirectUrl);
        window.location.href = redirectUrl;
        return new Promise(() => {});
      }
    }

    // Si el error es de tipo redirect a Cognito (respuesta del backend)
    if (
      error.response?.status === 401 &&
      error.response?.data?.redirectUrl &&
      !isPublicPath
    ) {
      logger.log('Handling 401 with redirectUrl');
      window.location.href = error.response.data.redirectUrl;
      return new Promise(() => {});
    }

    // Manejar errores 401 sin autenticación solo en rutas protegidas
    if (error.response?.status === 401 && !isPublicPath) {
      // window.location.href = `${process.env.REACT_APP_API_URL}/auth/login/redirect`;
      window.location.href = '/login';
      return new Promise(() => {});
    }

    return Promise.reject(error);
  }
);

export default api;
